import {
  Boxes,
  Building2,
  Calculator,
  CalendarDays,
  CreditCard,
  FileText,
  HandCoins,
  Hash,
  LayoutDashboard,
  Megaphone,
  OctagonAlert,
  Package,
  Receipt,
  ReceiptText,
  ShieldUser,
  ShoppingCart,
  Users,
  Warehouse,
  Wrench,
} from 'lucide-react';
import { NavigationItem } from '@/modules/navigation/types/navigation';

type NavigationLabels = {
  notices?: string;
  operations?: string;
  calendar?: string;
  dashboard?: string;
  services?: string;
  incidences?: string;
  inventory?: string;
  products?: string;
  stock?: string;
  consolidatedStock?: string;
  serialNumbers?: string;
  users?: string;
  customers?: string;
  billing?: string;
  quotes?: string;
  invoices?: string;
  deliveryNotes?: string;
  accounting?: string;
  purchasing?: string;
  suppliers?: string;
  purchaseInvoices?: string;
  workOrders?: string;
  finance?: string;
  accountsPayable?: string;
};

export const buildNavigationRoutes = (
  pathname: string,
  labels: NavigationLabels = {},
): NavigationItem[] => {
  return [
    {
      name: labels.dashboard ?? 'Dashboard',
      href: '/dashboard',
      icon: LayoutDashboard,
      module: 'DASHBOARD',
      isActive: pathname === '/dashboard',
    },
    {
      name: labels.notices ?? 'Avisos',
      href: '/operations/notices',
      icon: Megaphone,
      module: 'NOTIFICATIONS',
      isActive: pathname === '/operations/notices',
    },
    {
      name: labels.incidences ?? 'Incidencias',
      href: '/operations/incidences',
      icon: OctagonAlert,
      module: 'INCIDENCES',
      isActive: pathname === '/operations/incidences',
    },
    {
      name: labels.calendar ?? 'Agenda',
      href: '/operations/calendar',
      icon: CalendarDays,
      module: 'OPERATIONS',
      isActive: pathname?.startsWith('/operations/calendar'),
    },
    {
      name: labels.operations ?? 'Operaciones',
      icon: HandCoins,
      module: 'OPERATIONS',
      separator: 'top',
      isActive: pathname?.startsWith('/operations'),
      children: [
        {
          name: labels.services ?? 'Servicios',
          href: '/services',
          icon: Boxes,
          module: 'SERVICES',
          isActive: pathname?.startsWith('/services'),
        },
        {
          name: labels.workOrders ?? 'Partes de Trabajo',
          href: '/operations/work-orders',
          icon: Wrench,
          module: 'OPERATIONS',
          isActive: pathname?.startsWith('/operations/work-orders'),
        },
        {
          name: labels.users ?? 'Usuarios',
          href: '/users',
          icon: ShieldUser,
          module: 'USERS',
          isActive: pathname?.startsWith('/users'),
        },
        {
          name: labels.customers ?? 'Clientes',
          href: '/customers',
          icon: Users,
          module: 'CUSTOMERS',
          isActive: pathname?.startsWith('/customers'),
        },
      ],
    },
    {
      name: labels.inventory ?? 'Inventario',
      icon: Warehouse,
      module: 'PRODUCTS',
      isActive: pathname?.startsWith('/products') || pathname?.startsWith('/stock'),
      children: [
        {
          name: labels.products ?? 'Productos',
          href: '/products',
          icon: Package,
          module: 'PRODUCTS',
          isActive: pathname?.startsWith('/products'),
        },
        {
          name: labels.stock ?? 'Stock',
          href: '/stock',
          icon: Boxes,
          module: 'STOCK',
          isActive: pathname === '/stock',
        },
        {
          name: labels.serialNumbers ?? 'Números de serie',
          href: '/stock/serial-numbers',
          icon: Hash,
          module: 'STOCK',
          isActive: pathname?.startsWith('/stock/serial-numbers'),
        },
      ],
    },
    {
      name: labels.purchasing ?? 'Compras',
      icon: ShoppingCart,
      module: 'STOCK',
      isActive: pathname?.startsWith('/suppliers') || pathname?.startsWith('/purchase-invoices'),
      children: [
        {
          name: labels.suppliers ?? 'Proveedores',
          href: '/suppliers',
          icon: Building2,
          module: 'STOCK',
          isActive: pathname?.startsWith('/suppliers'),
        },
        {
          name: labels.purchaseInvoices ?? 'Facturas de Compra',
          href: '/purchase-invoices',
          icon: FileText,
          module: 'STOCK',
          isActive: pathname?.startsWith('/purchase-invoices'),
        },
      ],
    },
    {
      name: labels.billing ?? 'Facturación',
      icon: HandCoins,
      module: 'BILLING',
      isActive: pathname?.startsWith('/billing'),
      children: [
        {
          name: labels.quotes ?? 'Presupuestos',
          href: '/billing/quotes',
          icon: ReceiptText,
          module: 'BILLING',
          isActive: pathname === '/billing/quotes',
        },
        {
          name: labels.invoices ?? 'Facturas',
          href: '/billing/invoices',
          icon: Receipt,
          module: 'BILLING',
          isActive: pathname === '/billing/invoices',
        },
        {
          name: labels.deliveryNotes ?? 'Albaranes',
          href: '/billing/delivery-notes',
          icon: FileText,
          module: 'BILLING',
          isActive: pathname?.startsWith('/billing/delivery-notes'),
        },
      ],
    },
    {
      name: labels.finance ?? 'Finanzas',
      icon: CreditCard,
      module: 'ACCOUNTING',
      isActive: pathname?.startsWith('/accounts-payable') || pathname?.startsWith('/accounting'),
      children: [
        /*{
          name: labels.accountsPayable ?? 'Cuentas por Pagar',
          href: '/accounts-payable',
          icon: BarChart3,
          module: 'ACCOUNTING',
          isActive: pathname?.startsWith('/accounts-payable'),
        },*/
        {
          name: labels.accounting ?? 'Contabilidad',
          href: '/accounting',
          icon: Calculator,
          module: 'ACCOUNTING',
          isActive: pathname?.startsWith('/accounting'),
        },
      ],
    },
  ];
};
